export function formatPhone(value) {
  const original = String(value || "").trim();
  const digits = original.replace(/[\s.()-]/g, "");
  if (/^\d{10}$/.test(digits)) return digits.match(/.{2}/g).join(".");
  if (/^(\+33|0033)[1-9]\d{8}$/.test(digits)) {
    const prefix = digits.startsWith("+") ? "+33" : "0033";
    const number = digits.slice(prefix.length);
    return `${prefix}.${number[0]}.${number.slice(1).match(/.{2}/g).join(".")}`;
  }
  return original;
}
